import { RotateCw } from "lucide-react";

/**
 * Overlay-Komponente, die angezeigt wird, wenn das Gerät im Landscape-Modus ist
 * und Portrait-Modus erzwungen werden soll.
 *
 * Ähnlich wie Instagram: Zeigt eine freundliche Aufforderung, das Gerät zu drehen.
 */
export function PortraitLockOverlay(): JSX.Element {
  return (
    <div className="fixed inset-0 z-[9999] bg-background flex items-center justify-center p-4">
      <div className="text-center max-w-md mx-auto">
        <div className="mb-8">
          <RotateCw className="w-24 h-24 mx-auto text-primary animate-pulse" />
        </div>

        <h1 className="text-2xl font-bold text-foreground mb-4">
          Bitte drehe dein Gerät
        </h1>

        <p className="text-muted-foreground mb-6 leading-relaxed">
          CoupleUp ist für die optimale Nutzung im Hochformat (Portrait)
          entwickelt. Bitte drehe dein Gerät in den Hochkant-Modus, um
          fortzufahren.
        </p>

        <div className="bg-muted/50 rounded-lg p-4 mb-6">
          <p className="text-sm text-muted-foreground">
            <strong>Tipp:</strong> Halte dein Gerät senkrecht, damit die Höhe
            größer als die Breite ist.
          </p>
        </div>
      </div>
    </div>
  );
}
